import FormSelect from '../atoms/FormSelect';
import { useState } from 'react';
import dayjs from 'dayjs';
import MessageBar from '../atoms/MessageBar';
import { Button, TextField } from '@mui/material';
import { useAddAttendanceBySession } from '../../hooks/events.hook';

const AddToEventByLevel = () => {
  let statusMsg = '';
  const { sessions, addUserMutation } = useAddAttendanceBySession();

  // generate levels for select box
  let levelArray = [];
  for (let x = 1; x <= 10; x++) {
    levelArray.push({
      id: x,
      label: 'Level ' + x,
    });
  }

  if (addUserMutation.isSuccess) {
    statusMsg = 'Attendance added successfully';
  } else if (addUserMutation.isError) {
    statusMsg = 'Oops, something went wrong.';
  }

  return (
    <div>
      <div>Select Level</div>
      <div>
        <FormSelect
          propId='levelSelect'
          options={levelArray}
          valueKey='id'
          labelKey='label'
          ariaLabel='Select Level'
        />
      </div>
      <div className='spacer'></div>
      <div>Select Session</div>
      <div>
        <FormSelect
          propId='sessionSelect'
          options={sessions}
          valueKey='id'
          labelKey='session'
          ariaLabel='Select Session'
        />
      </div>
      <div className='spacer'></div>
      <div>Attendance Date (YYYY-MM-DD)</div>
      <div>
        <TextField
          type='text'
          id='eventDate'
          className='customTextField'
          placeholder='YYYY-MM-DD'
          defaultValue={dayjs().format('YYYY-MM-DD')}
          inputProps={{
            'aria-label': 'Attendance Date',
            'data-cy': 'event-date',
          }}
        />
      </div>
      <div className='spacer'></div>
      <div>
        <Button onClick={() => addUserMutation.mutate()} variant='contained'>
          Add
        </Button>
      </div>
      <div className='spacer'></div>
      <MessageBar msg={statusMsg} type='success' />
    </div>
  );
};

export default AddToEventByLevel;
